<div class="category-menu" [class.mobile]="responsiveService.isMobile()">
  @for (tile of tiles(); track tile.key; let i = $index) {
    <app-v3-score-category-tab
      [label]="tile.label"
      [value]="tile.value"
      [max]="tile.max"
      [colorVar]="tile.v3ColorVar"
      [isRatingSuspended]="tile.isRatingSuspended"
      [active]="activeIndex() === i"
      (click)="selectTab(i)"
    ></app-v3-score-category-tab>
  }
</div>

@if (isDesktopBreakdown()) {
  <div class="category-columns" [appV3TabPanel]="activeIndex()">
    <div class="column">
      @for (card of leftColumnCards(); track card.key) {
        <app-v3-category-card
          [key]="card.key"
          [title]="card.title"
          [criteria]="card.criteria"
          [isRedFlag]="card.isRedFlag"
        ></app-v3-category-card>
      }
    </div>
    <div class="divider"></div>
    <div class="column">
      @for (card of rightColumnCards(); track card.key) {
        <app-v3-category-card
          [key]="card.key"
          [title]="card.title"
          [criteria]="card.criteria"
          [isRedFlag]="card.isRedFlag"
        ></app-v3-category-card>
      }
    </div>
  </div>
} @else {
  <div class="category-breakdown">
    <div class="section-title">
      <span class="notch"></span>
      <h2>Bewertung nach Kategorie</h2>
    </div>

    @if (nonRedFlagCards().length) {
      <div class="category-cards" [appV3TabPanel]="activeIndex()">
        @for (card of nonRedFlagCards(); track card.key) {
          <app-v3-category-card
            [key]="card.key"
            [title]="card.title"
            [criteria]="card.criteria"
          ></app-v3-category-card>
        }
      </div>
    }
  </div>

  @if (redFlagCard(); as card) {
    <div class="category-breakdown">
      <div class="section-title">
        <span class="notch"></span>
        <span class="warning-icon"></span>
        <h2>Red Flags</h2>
      </div>

      <div class="category-cards" [appV3TabPanel]="activeIndex()">
        <app-v3-category-card
          [key]="card.key"
          [title]="card.title"
          [criteria]="card.criteria"
          [isRedFlag]="true"
        ></app-v3-category-card>
      </div>
    </div>
  }
}
